// Shared form-field definitions for Advance Search Service.
// Imported by both the page (advanceSearchService.vue) and the reusable form
// component (ServiceSearchForm.vue) so the URL-sync key list never drifts.

export const initialFormData = {
  service: "",
  item_name: "",
  mcr_number: "",
  service_category: "",
  service_group: "",
  uom: "",
  valuation_class: "",
  group_class: "",
  created_at: "",
};

export const queryFields = Object.keys(initialFormData);
